import React from 'react';
import {Images,TextArea,Page} from '../index';
import {Btn} from '../../Common/index';
import styled from 'styled-components';
import comic1 from '../../../asset/img/comic/otomo/comic18_1.png';
import comic2 from '../../../asset/img/comic/otomo/comic18_2.png';

const H2 = styled.h2`
 font-size: 2em;
 `

const Story8 = () => {
    return(
        <div className="common__item">
        <div className="common__center">
  <H2>立花ドウセツは漢字が嫌い</H2>
  <Images 
  image_1= {comic1}
  image_2= {comic2}
  style3= "display-none"
   alt_1= "立花ドウセツは漢字が嫌い"
   alt_2= "立花ドウセツは漢字が嫌い"
  />
  <TextArea 
   text1="「立花道雪(ドウセツ)」は大友家を代表する忠節深い武将です。"
   text2="かっこよく忠節のイメージ強い道雪ですが、逸話には「漢字があまり好きじゃない」との内容もあります。"
   text3="なかなか「龍造寺隆信」は画数が多いので‥おっほん‥"
   data="2019/05-06"
  />
  <Btn
   text="一覧に戻る"
   link="/comic"
  />
 </div>
 </div>
    )
}
export default Story8;